import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import colors from '../../util/colors.js';
import { Icon } from '../Icon/Icon.component.js';
import { ContextualAlertButton } from '../ContextualAlertButton/ContextualAlertButton.component.js';
import { CloseTimer } from '../CloseTimer/CloseTimer.component.js';
import { propTypes, defaultProps } from './Banner.types.js';
import styles from './Banner.module.scss.js';

var iconMap = {
    success: 'SuccessIcon',
    warning: 'WarningIcon',
    danger: 'DangerIconTriangle',
    informative: 'InformativeIcon',
};
var colorMap = {
    success: colors.success80,
    warning: colors.warning90,
    danger: colors.danger80,
    informative: colors.informative80,
};
var noop = function () {
    /* This handler doesn't do anything */
};
/**
 * Use banners to comunicate important or new information to the user.
 */
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Banner.prototype.componentDidMount = function () {
        if (this.props.styling) {
            console.warn('DEPRECATION WARNING: The `styling` prop is deprecated and support for it will be removed soon. Please use `variant` instead.');
        }
    };
    Banner.prototype.render = function () {
        var _a = this.props, message = _a.message, actions = _a.actions, onClick = _a.onClick, onDismiss = _a.onDismiss, buttonText = _a.buttonText, styling = _a.styling, urgent = _a.urgent, className = _a.className, timeout = _a.timeout, hideIcon = _a.hideIcon;
        if (!urgent) {
            console.warn("Prop 'urgent' is deprecated");
        }
        var variant = styling || this.props.variant;
        var hasActions = Boolean(actions);
        var showCloseButton = Number.isFinite(timeout) || onDismiss;
        var showIcon = hideIcon !== undefined ? !hideIcon : !showCloseButton;
        return (React__default.createElement("div", { "data-testid": this.props['data-testid'], className: clsx(styles.Banner, styles["Banner___" + variant], urgent && styles.Banner___urgent, hasActions && styles.Banner___withActions, className) },
            React__default.createElement("div", { className: styles.Banner_message },
                showIcon && (React__default.createElement(Icon, { size: 24, name: iconMap[variant], alt: variant, className: styles.Icon })),
                React__default.createElement("span", { className: clsx(styles.Banner_messageText, !showIcon &&
                        styles.Banner_messageText___paddingLeft) }, message)),
            React__default.createElement("div", { className: styles.Banner_action },
                hasActions && actions,
                !hasActions && !showCloseButton && onClick && (React__default.createElement(ContextualAlertButton, { onClick: onClick, variant: variant }, buttonText)),
                showCloseButton && (React__default.createElement(CloseTimer, { color: colorMap[variant], duration: timeout || 0, onClick: onDismiss || onClick || noop })))));
    };
    Banner.displayName = 'Banner';
    Banner.propTypes = propTypes;
    Banner.defaultProps = __assign({}, defaultProps);
    return Banner;
}(React__default.Component));

export { Banner as default };
